module.exports = __webpack_public_path__ + "media/images/official/bnr_plancheck_pc-59e43b11a1fe092f4ce9269630f4546c.jpg";